import { logout, profile, queryCurrentUser } from '@/services/ant-design-pro/api';
import { LogoutOutlined, SettingOutlined, UserOutlined, LockOutlined } from '@ant-design/icons';
import { history, useModel } from '@umijs/max';
import type { MenuProps } from 'antd';
import { Spin, Tooltip, Tag, message } from 'antd';
import { createStyles } from 'antd-style';
import { stringify } from 'querystring';
import type { MenuInfo } from 'rc-menu/lib/interface';
import React, { useCallback, useEffect, useState } from 'react';
import { flushSync } from 'react-dom';
import HeaderDropdown from '../HeaderDropdown';
import ChangePasswordModal from './ChangePasswordModal';
import userIcon from '../../../public/imgs/user.png';
import { IconHeart, IconKey, IconLogout } from '../CustomIcon';


export type GlobalHeaderRightProps = {
  menu?: boolean;
  children?: React.ReactNode;
};

export const AvatarName = () => {
  const { user } = useModel('user');
  return <span className="anticon">{user?.nickname}</span>;
};

const useStyles = createStyles(({ token }) => {
  return {
    action: {
      display: 'flex',
      height: '48px',
      marginLeft: 'auto',
      overflow: 'hidden',
      alignItems: 'center',
      padding: '0 8px',
      cursor: 'pointer',
      borderRadius: token.borderRadius,
      '&:hover': {
        backgroundColor: token.colorBgTextHover,
      },
    },
  };
});

export const AvatarDropdown: React.FC<GlobalHeaderRightProps> = ({ menu, children }) => {
  /**
   * 退出登录，并且将当前的 url 保存
   */
  const loginOut = async () => {
    try {
      await logout();
    } catch (e) {
      console.error(e);
    }
  };
  const { styles } = useStyles();

  const { user, clearUser } = useModel('user');
  const [info, setInfo] = useState<{ staffNameCn?: string; staffNameEn?: string; staffNo?: string; roleNames?: any[] }>();
  const [changePasswordVisible, setChangePasswordVisible] = useState(false);
  // useEffect(() => {
  //   const pathname = typeof window !== 'undefined' ? window.location.pathname : '';
  //   if (['/user/login', '/user/logout', '/401', '/404'].includes(pathname)) return;

  //   profile().then((res) => {
  //     const d = res?.data;
  //     setInfo({ staffNameCn: d?.staffNameCn, staffNameEn: d?.staffNameEn, staffNo: d?.staffNo, roleNames: d?.roleNames as any[] });
  //   }).catch(() => {});
  // }, []);

  const onMenuClick: MenuProps['onClick'] = useCallback(
    async (event: MenuInfo) => {
      const { key } = event;
      console.log(key);
      if (key === 'logout') {
        await loginOut();
        flushSync(() => {
          clearUser();
          localStorage.removeItem('token');
          localStorage.removeItem('userInfo');
        });
        history.push('/login');
        return;
      }
      if (key === 'changePassword') {
        setChangePasswordVisible(true);
        return;
      }
    },
    [clearUser],
  );

  const loading = (
    <span className={styles.action}>
      <Spin
        size="small"
        style={{
          marginLeft: 8,
          marginRight: 8,
        }}
      />
    </span>
  );

  if (!user || !user.nickname) {
    return loading;
  }

  const menuItems = [
    ...(menu
      ? [
          {
            key: 'center',
            icon: <UserOutlined />,
            label: '个人中心',
          },
          {
            key: 'settings',
            icon: <SettingOutlined />,
            label: '个人设置',
          },
          {
            type: 'divider' as const,
          },
        ]
      : []),
    {
      key: 'changePassword',
      icon: <IconKey style={{ fontSize: '1.1em' }} />,
      // icon: <SettingOutlined />,
      label: '修改密码',
    },
    {
      key: 'logout',
      icon: <IconLogout style={{ fontSize: '0.8em' }}/>,
      label: '退出登录',
    },
  ];

  return (
    <>
      <HeaderDropdown
        menu={{
          selectedKeys: [],
          onClick: onMenuClick,
          items: menuItems,
        }}
        popupRender={(menuNode) => (
          <div
            style={{
              background: '#fff',
              borderRadius: 8,
              boxShadow:
                '0 6px 16px rgba(0,0,0,0.08), 0 3px 6px rgba(0,0,0,0.12), 0 9px 28px rgba(0,0,0,0.05)',
              overflow: 'hidden',
            }}
          >
            <div
              style={{
                padding: '12px 16px',
                borderBottom: '1px solid #f0f0f0',
                color: 'rgba(0,0,0,0.88)',
                fontSize: 14,
                lineHeight: '22px',
                display: 'grid',
                gap: 8,
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <img src={userIcon} alt="" style={{ width: 32, height: 32, borderRadius: 4 }} />
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <span style={{ fontWeight: 500 }}>{user?.nickname || '-'}</span>
                  <span>{user?.account || '-'}</span>
                </div>
              </div>
              {!!(user?.roleList && (user?.roleList as any[]).length) && (
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8 }}>
                  <span
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: 12,
                      padding: '2px 6px',
                      color: '#000',
                      letterSpacing: 0.5,
                    }}
                  >
                    角色:
                  </span>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 6 }}>
                    {(user?.roleList as any[]).map((r, i) => (
                      <Tag key={i}>
                        {typeof r === 'string'
                          ? r
                          : typeof r?.name === 'string'
                          ? r.name
                          : typeof r?.roleName === 'string'
                          ? r.roleName
                          : JSON.stringify(r)}
                      </Tag>
                    ))}
                  </div>
                </div>
              )}
            </div>
            {menuNode}
          </div>
        )}
      >
        {children}
      </HeaderDropdown>
      <ChangePasswordModal
        visible={changePasswordVisible}
        onCancel={() => setChangePasswordVisible(false)}
        onSuccess={() => setChangePasswordVisible(false)}
      />
    </>
  );
};
